import { Component, OnInit, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals/globals';
import { AuthorizationInfo } from 'src/app/shared/models/data/authInfo.model';
import { Groups } from 'src/app/shared/models/data/groups.model';
import { UserForGrid, Users } from 'src/app/shared/models/data/users.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftModalService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-modal.service';
import { CustomIcoCol } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { TeiasoftModalReturnObject } from 'src/app/shared/teiasoft-bucket/teiasoft-modal/teiasoft-modal.component';
import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';
import { parseGridActionEvent } from 'src/app/shared/utils/grid-event.utils';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy{
  users: Users = new Users();
  columnsToHide: string[] = ['isDefaultOfficeEditable'];
  minWidthVw:number = 94.2;
  isLoaded: boolean = false;
  usersForGrid: UserForGrid[] = new Array();
  subscriptions: Subscription = new Subscription();
  groups: Groups  = new Groups();
  authInfo: AuthorizationInfo = new AuthorizationInfo();
  customIcoCols: CustomIcoCol[] = new Array();
  buttonsList: TTButton[] = new Array();
  action: string = "";
  showModalUser: boolean = false;
  columnsToShow: string[] = ['username','officeCode','mill','groupCode','creationDate','lastUpdate','lastLogin'];
  userNameToEdit: string = "";

  // Filters
  openFilter: boolean = false;
  isDataFiltered: boolean = false;
  clearFilters: boolean = false;

  constructor(private teiasoftLoader: TeiasoftLoaderService, private backendService: BackendService, public globals: Globals, 
    private teiasoftModalService: TeiasoftModalService, private translate: TranslateService, private router: Router){
    this.buildButtonsList(false);
  }

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  
  buildButtonsList(onlyButtons: boolean) {
    this.buttonsList = new Array();
    let _item: TTButton = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-plus';
    _item.id = 0;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "addUser";
    _item.action = "add";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* SHOW/HIDE FILTER */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = this.openFilter == false? 'fal fa-filter' : 'fal fa-filter-circle-xmark';
    _item.id = 7;
    _item.size = "";
    _item.text = "";
    _item.tooltip = this.openFilter == false ? "showGridFilters" : "hideGridFilters";
    _item.action = this.openFilter == false ? "showFilter" : "closeFilter";
    _item.type = '';
    _item.state =  this.isDataFiltered == true ?'pressed': '';
    this.buttonsList.push(_item);

    /* CLEAR FILTERS */
    _item = new TTButton();
    _item.disabled = !this.openFilter ? true : false;
    _item.icon = 'fal fa-eraser';
    _item.id = 8;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "clearGridFilters";
    _item.action = "clearFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-layer-group';
    _item.id = 1;
    _item.size = "";
    _item.text = "manageGroups";
    _item.tooltip = "manageGroups";
    _item.action = "manageGroups";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    if (onlyButtons == false)
      this.buildCustomIconGrid();
  }

  
  buildCustomIconGrid() {
    this.customIcoCols = new Array();
    let _item: CustomIcoCol = new CustomIcoCol();
    _item.action = 'deleteUser';
    _item.icon = 'fal fa-trash-alt';
    _item.label ="deleteUser";
    this.customIcoCols.push(_item);

    _item = new CustomIcoCol();
    _item.action = "editUser"; 
    _item.icon = 'fal fa-pencil-alt';
    _item.label = "editUser";
    this.customIcoCols.push(_item);

    this.getAuthorizationsInfo();
  }

  getAuthorizationsInfo() {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getAuthorizationsInfo().subscribe(res => {
      this.authInfo = new AuthorizationInfo();
      this.authInfo = res;
      this.getGroups();
    }));
  }

  getGroups(){
    this.subscriptions.add(this.backendService.getGroups(null).subscribe(res => {
      this.groups = new Groups();
      this.groups = res;
      this.getUsers();
    }));
  }

  getUsers(){
    this.subscriptions.add(this.backendService.getUsers(null).subscribe(res => {
      if (res){
        this.users = new Users();
        this.users = JSON.parse(JSON.stringify(res));
        this.usersForGrid = new Array();

        for (var x=0; x < this.users.users!.length; x++){
          let _item: UserForGrid = new UserForGrid();
          _item.creationDate = this.users.users![x].creationDate;
          let _grp: string = "";
          for (var p=0; p < this.users.users![x].groupsId!.length; p++){
            _grp = _grp + this.groups.groups!.filter(k => k.groupId == this.users.users![x].groupsId![p])[0].groupName + ";";
          }
          _item.groupCode = _grp.substring(0,(_grp.length-1));

          _item.isDefaultOfficeEditable = this.users.users![x].isDefaultOfficeEditable;
          _item.lastLogin =  this.users.users![x].lastLogin;
          _item.lastUpdate =  this.users.users![x].lastUpdate;

          if (this.authInfo.mills!.filter(k => k.millId == this.users.users![x].defaultMillId)[0])
            _item.mill = this.authInfo.mills!.filter(k => k.millId == this.users.users![x].defaultMillId)[0].shortName;
          else
            _item.mill = "";

          if (this.authInfo.offices!.filter(k => k.officeId == this.users.users![x].defaultOfficeId)[0])
            _item.officeCode = this.authInfo.offices!.filter(k => k.officeId == this.users.users![x].defaultOfficeId)[0].officeCode;
          else
            _item.officeCode = "";

          _item.username =  this.users.users![x].username;
          this.usersForGrid.push(_item);
        }
        this.usersForGrid = this.usersForGrid.sort((a,b) => (a.username! > b.username!) ? 1 : ((b.username! > a.username! ? -1 : 0)));
        this.isLoaded = true;
      }
      this.teiasoftLoader.stop();
    }));
  }

  deleteUser(username: string){
    this.teiasoftLoader.start();
    this.subscriptions.add(
      this.backendService.deleteUser(username).subscribe(res => {
        this.getUsers();
      })
    );
  }

  /* EVENTS */
  customIconClick(evt:any){
    const { action: _action, row: _obj } = parseGridActionEvent(evt);
    if (_action == 'deleteUser'){
      let _param: string = _obj["username"];
      let _message: string = this.translate.instant("users.confirmDeleteUser").replace("{0}", _param);
      this.teiasoftModalService.show('confirm', this.translate.instant("users.deleteUser"), _message, _param, 'confirmDeleteUser');
    } else {
      this.action = 'edit';
      this.userNameToEdit = _obj["username"];
      this.showModalUser = true;
    }
  }

  onConfirmModal(evt:TeiasoftModalReturnObject) {
    if (evt.closeFlag == 'confirmDeleteUser'){
      this.deleteUser(evt.parameter!);
    }
  }

  onBtnToolbarClick(btn: TTButton) {
    if (btn.action == 'add') {
      this.action = 'create';
      this.showModalUser = true;
    }

    if (btn.action == 'manageGroups'){
      this.router.navigate(["/groups"]);
    }

    if (btn.action == 'showFilter'){
      this.openFilter = true;
      this.buildButtonsList(true);
    }

    if (btn.action == 'closeFilter'){
      this.openFilter = false;
      this.buildButtonsList(true);
    }

    if (btn.action == 'clearFilter'){
      this.clearFilters = true;
      setTimeout(() => this.clearFilters = false, 250);
    }
  }

  closeModalUser(evt:any){
    if (evt == 'reload'){
      this.teiasoftLoader.start();
      this.getUsers();
    }
    this.action = '';
    this.userNameToEdit = '';
    this.showModalUser = false;
  }

  imFiltering(evt: boolean){
    this.isDataFiltered = evt;
    this.buildButtonsList(true);
  }
}